// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
export interface ITriggerValueOverride {
	mn: number | undefined;

	ad: number | undefined;

	mx: number | undefined;

	$type?: string | undefined;
}
export class TriggerValueOverride {
	constructor(data?: ITriggerValueOverride) {
		if (!data) return;
		if (data.$type && data.$type !== this.$type) console.warn('The $type of data being parsed does not match the type of the object being created (' + this.$type + ')');
		Object.assign(this, data);
	}

	mn: number | undefined;

	ad: number | undefined;

	mx: number | undefined;

	static $type: string = "Shared.Models.Api.V1.DeviceCommands.TriggerValueOverride, ";
	$type?: string | undefined = TriggerValueOverride.$type;
}

